import { useTranslation } from 'react-i18next';
import Text from '@/components/atoms/Text/Text';
import Section from '@/components/molecules/Section/Section';

const TermsContent: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <Text variant="title" className="mb-2">{t('termsAndPrivacyModal.terms.title')}</Text>
        <Text variant="caption">{t('termsAndPrivacyModal.terms.effectiveDate')}</Text>
      </div>
  
      <div className="space-y-4">
        <Section number="1" title={t('termsAndPrivacyModal.terms.sections.company.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.company.content')}
        </Section>
        
        <Section number="2" title={t('termsAndPrivacyModal.terms.sections.eligibility.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.eligibility.content')}
        </Section>
        
        <Section number="3" title={t('termsAndPrivacyModal.terms.sections.use.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.use.content')}
        </Section>
        
        <Section number="4" title={t('termsAndPrivacyModal.terms.sections.noOffer.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.noOffer.content')}
        </Section>
        
        <Section number="5" title={t('termsAndPrivacyModal.terms.sections.ip.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.ip.content')}
        </Section>
        
        <Section number="6" title={t('termsAndPrivacyModal.terms.sections.thirdParty.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.thirdParty.content')}
        </Section>
        
        <Section number="7" title={t('termsAndPrivacyModal.terms.sections.liability.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.liability.content')}
        </Section>
        
        <Section number="8" title={t('termsAndPrivacyModal.terms.sections.indemnification.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.indemnification.content')}
        </Section>
        
        <Section number="9" title={t('termsAndPrivacyModal.terms.sections.law.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.law.content')}
        </Section>
        
        <Section number="10" title={t('termsAndPrivacyModal.terms.sections.changes.title')} whiteNumbers={true}>
          {t('termsAndPrivacyModal.terms.sections.changes.content')}
        </Section>
      </div>
    </div>
  );
};

export default TermsContent;